import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import SubscriptionSection from '../components/SubscriptionSection';
import OrgSettingsSection from '../components/OrgSettingsSection';
import AccountSection from '../components/AccountSection';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import TeamPage from '../../teamSection/pages/TeamPage';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import UserNotificationSection from '../components/UserNotificationSection';
import IntegrationsSection from '../components/IntegrationsSection';

export default function SettingsPage() {
  useDocumentTitle('Settings');
  const user = useSelector((state) => state.org.org.user);
  const subscription = useSelector((state) => state.org.org.subscription);
  const isFromPartner = subscription?.isFromPartner;
  const isApiIntegrationEnabled = subscription?.features?.api_integration_enabled;
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const tabFromUrl = searchParams.get('tab');
  const defaultTab = user?.is_admin && !isFromPartner ? 'subscription' : 'email';
  const [value, setValue] = React.useState(tabFromUrl || defaultTab);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSearchParams({ tab: newValue });
  };

  React.useEffect(() => {
    if (!tabFromUrl) {
      setSearchParams({ tab: defaultTab });
    }
  }, [tabFromUrl, defaultTab, setSearchParams]);

  React.useEffect(() => {
    if (tabFromUrl === 'apiIntegration' && !isApiIntegrationEnabled) {
      navigate('/settings?tab=subscription', { replace: true });
    }
  }, [tabFromUrl, isApiIntegrationEnabled, navigate]);

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        textColor="primary"
        indicatorColor="primary"
        aria-label="settings tabs"
      >
        {user?.is_admin && !isFromPartner && <Tab value="subscription" label="Subscription & Billing" />}
        {user?.is_admin && <Tab value="orgSettings" label="Organization Settings" />}
        <Tab value="email" label="User Settings" />
        {user?.is_admin && <Tab value="member" label="Team Management" />}
        <Tab value="account" label="Account" />
        <Tab value="integrations" label="Integrations" />
      </Tabs>

      <Box sx={{ p: 2 }}>
        {value === 'subscription' && <SubscriptionSection />}
        {value === 'orgSettings' && <OrgSettingsSection />}
        {value === 'email' && <UserNotificationSection />}
        {value === 'account' && <AccountSection />}
        {value === 'member' && <TeamPage />}
        {value === 'integrations' && <IntegrationsSection />}
      </Box>
    </Box>
  );
}
